import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { 
    chain, 
    DispatchBeginBatchLoadProducts, 
    RequestDataFromApi 
} from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import { batchGetProducts } from "@midland-industries/Services/BatchGetProductsService";

type BatchLoadProductsProps = Parameters<typeof DispatchBeginBatchLoadProducts>[0];

async function XcRequestDataFromApi(props: BatchLoadProductsProps) {
    props.result.apiResult = await batchGetProducts(props.result.apiParameter);
}

replaceInChain(chain, RequestDataFromApi, XcRequestDataFromApi);


